/* eslint-disable no-param-reassign */

export default {
  state: {
    fetched: false,
  },

  actions: {
    fetch({
      commit,
    }) {
      commit('fetch');
    },
  },

  mutations: {
    fetch(state) {
      state.fetched = true;
    },
  },
};
